<sd-4-5-1-icon library="{{iconLibrary}}" [name]="iconName" color="{{ iconColor }}"></sd-4-5-1-icon>
